import axios from "axios"

export default axios.create({
  baseURL: "https://gpn1ji1ou7.execute-api.us-east-1.amazonaws.com/test/"
})
                                                                            


